import { lazy } from 'react';
import { AchIcon, ChargebacksIcon, UnclassifiedIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';
import { achRoutes } from '../pages/luci/ach/routes.ach';
import { chargebacksRoutes } from '../pages/luci/chargebacks/routes.chargebacks';

const prefixPath = '/luci';

const UFUnclassifiedView = lazy(
  () =>
    import(
      /* webpackChunkName: "LuciRoutes" */ '../pages/luci/unclassified/UFUnclassified'
    )
);

const ChargebacksView = lazy(
  () =>
    import(
      /* webpackChunkName: "LuciRoutes" */ '../pages/luci/chargebacks/UFChargebacks'
    )
);

const AchView = lazy(
  () => import(/* webpackChunkName: "LuciRoutes" */ '../pages/luci/ach/UFAch')
);

export const luciRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [prefixPath, `${prefixPath}/*`]
    },
    {
      name: 'Uncollected funds',
      path: `${prefixPath}/uncollected-funds`,
      component: UFUnclassifiedView,
      exact: true,
      icon: UnclassifiedIcon,
      pages: []
    },
    {
      name: 'Chargebacks',
      path: `${prefixPath}/chargebacks`,
      icon: ChargebacksIcon,
      component: ChargebacksView,
      pages: chargebacksRoutes
    },
    {
      name: 'ACH',
      path: `${prefixPath}/ach`,
      icon: AchIcon,
      component: AchView,
      pages: achRoutes
    }
  ]
};
